import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// import { IndexComponent } from '../components/index/index.component';
import { BiometricCaptureComponent } from "./biometric-capture/biometric-capture.component";
// import { CaptureCompleteComponent } from './capture-complete/capture-complete.component';
import { LayoutComponent } from "./layouts/layout.component";
import { FingerCaptureTestComponent } from "./finger-capture-test/finger-capture-test.component";

const routes: Routes = [
  // {
  //   path: "biometric-capture/webhook/:webhook/auth_key/:auth_key/identifier/:identifier/finger_option/:finger_option",
  //   component: BiometricCaptureComponent,
  // },
  {
    path: "biometric-capture/webhook/:webhook/auth_key/:auth_key/identifier/:identifier",
    component: BiometricCaptureComponent,
  },
  {
    path: "finger-capture-test/:selectedFinger",
    component: FingerCaptureTestComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
